import { render, staticRenderFns } from "./WrongTopic.vue?vue&type=template&id=5e6d32ea&scoped=true"
import script from "./WrongTopic.vue?vue&type=script&lang=js"
export * from "./WrongTopic.vue?vue&type=script&lang=js"
import style0 from "./WrongTopic.vue?vue&type=style&index=0&id=5e6d32ea&prod&scoped=true&lang=css"
import style1 from "./WrongTopic.vue?vue&type=style&index=1&id=5e6d32ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d32ea",
  null
  
)

export default component.exports